export enum ProjectCountryCount {
  MORE_THAN_8 = 1,
  UP_TO_8 = 0,
}
